module.exports = __webpack_public_path__ + "static/img/woman-default-blue.62d17048.png";